import clsx from "clsx";
import { FC } from "react";

import { CourseGroupingView } from "./CourseGroupingView";
import { CourseNavList } from "./CourseNavList";

import type { SectionViewOption } from "components/menus/SectionViewOptionMenu";
import { useIsMdOrLarger } from "mds/hooks/use-responsive";
import { useAppSelector } from "store/index";
import { selectHasCourses, selectIsEditingOrgSettings } from "store/selectors";

const COURSE_EVENT_PREFIX = "Home - Course Catalog / ";

export const CourseCodeView: FC<{ onOptionChange: (option: SectionViewOption) => void }> = ({
  onOptionChange,
}) => {
  const hasCourses = useAppSelector(selectHasCourses);
  const canEdit = useAppSelector(selectIsEditingOrgSettings);
  const isSmallScreen = !useIsMdOrLarger();

  return (
    <div
      className={clsx(
        "flex h-full w-full items-start",
        isSmallScreen && "flex-col overflow-y-auto pb-4",
      )}
    >
      {hasCourses && <CourseNavList canEdit={canEdit} onOptionChange={onOptionChange} />}

      <main className={clsx("w-full", !isSmallScreen && "h-full flex-auto overflow-y-auto")}>
        <CourseGroupingView canEdit={canEdit} eventPrefix={COURSE_EVENT_PREFIX} />
      </main>
    </div>
  );
};
